<template>
    <div class="question-badge-list d-flex align-center justify-content-between" v-for="badge in badges" :key="badge.badge_id">
        <div class="question-badge" v-if="badge.name">
            <router-link :to="badge.link" class="q-badge badge" :class="'badge-'+badge.rank">{{badge.name}}</router-link>
        </div>
        <div class="question-badge-content">
            <p>{{badge.content}}</p>
        </div>
        <span class="question-badge-award">{{badge.award_count}} awarded</span>
    </div>
</template>

<script>
export default {
    name: 'QuestionBadge',
    props: ['badges'],
    data() {
        return {

        }
    }
}
</script>